// @ts-nocheck
/* eslint-disable */
export const flChatSendIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.10526 12L2 23L23 12L2 0.999999L6.10526 12ZM5.70082 5.19629L8.24001 12L5.70083 18.8037L18.6897 12L5.70082 5.19629Z" fill="currentColor"/><path d="M7 12H13" stroke="currentColor" stroke-width="2"/></svg>`,
    name: 'chat-send' as const
};